import { render } from "./FarmCard.vue?vue&type=template&id=167b6060&scoped=true"
import script from "./FarmCard.vue?vue&type=script&lang=js"
export * from "./FarmCard.vue?vue&type=script&lang=js"

import "./FarmCard.vue?vue&type=style&index=0&id=167b6060&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-167b6060"

export default script